import { render } from "./GeneralCommentsBlock.vue?vue&type=template&id=80c2e1b4&scoped=true"
import script from "./GeneralCommentsBlock.vue?vue&type=script&lang=js"
export * from "./GeneralCommentsBlock.vue?vue&type=script&lang=js"

import "./GeneralCommentsBlock.vue?vue&type=style&index=0&id=80c2e1b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c2e1b4"]])

export default __exports__